import { Box } from "@mui/material";
import React from "react";
import type { ListProps } from "react-virtuoso";
import { useListVirtualizedContext } from "./context";

export const VirtuosoList = React.forwardRef(function VirtuosoList({ children, ...props }: ListProps, ref) {
  const { List } = useListVirtualizedContext();

  return (
    <Box {...props} {...List} ref={ref}>
      {children}
    </Box>
  );
});
